import { useOptionalAiWidgetConfig } from '@atlassian/csm-ai-search-trigger';

/**
 * Looks for the AI widget config context, and if it is present with `center` widget position enabled returns true to render the AI search trigger in the hero element.
 * This is used to determine if the AI search trigger should be rendered in the hero element.
 */
export const useShouldHeroRenderAiSearch = () => {
    const widgetConfigContext = useOptionalAiWidgetConfig();

    return Boolean(
        widgetConfigContext &&
            widgetConfigContext.supportWidgetConfig.isEnabled &&
            widgetConfigContext.supportWidgetConfig.widgetPosition === 'CENTER'
    );
};
